<template>
  <div
    class="field"
    :class="additionalClasses"
  >
    <label :for="_uid">{{ label }}</label>
    <ValidationProvider
      v-slot="{ validate, errors }"
      :rules="rules"
    >
      <div class="select">
        <country-select
          :id="_uid"
          :value="value"
          :required="required"
          placeholder=""
          :class="{'error': errors.length}"
          :country="value"
          top-country="US"
          @blur="validate"
          @input="$emit('input', $event), validate($event)"
        />
      </div>
      <div v-if="errors.length" class="error__text">
        {{ errors[0] }}
      </div>
    </ValidationProvider>
    <pre style="display: none">{{ value }}</pre>
  </div>
</template>

<script>
import usesValidation from '@/mixins/veeValidate'
import countries from '@/core/data/countries.json'
export default {

  name: 'DSCountrySelect',

  mixins: [
    usesValidation,
  ],

  props: {
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: 'required',
    },
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      countries,
    }
  },

  computed: {
    additionalClasses() {
      return {
        required: this.required,
      }
    },
  },
}
</script>
